import { useAccountCompanyId } from 'application/hooks';
import { useBillingInfo } from '@entities/billing';

import { OrganizationDiscountPureType } from '@shared/api/graphql/generated';

interface UseDiscount {
  discount: OrganizationDiscountPureType | null;
  nextBillingPriceAmount: number;
}

const useDiscount = (): UseDiscount => {
  const companyId = useAccountCompanyId();

  const { discount, nextBillingPriceAmount } = useBillingInfo(companyId);

  return {
    discount,
    nextBillingPriceAmount: nextBillingPriceAmount || 0,
  };
};

export default useDiscount;
